
import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './layout/App'

const root = createRoot(document.getElementById('App'))
root.render(<App />)
